import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export function StaticPage({ title, children }) {
  return (
    <div className="grain relative min-h-screen pb-32">
      <div className="mx-auto max-w-3xl px-6 pt-28 sm:px-10">
        <Link to="/" className="mb-8 inline-block text-xs font-semibold uppercase tracking-widest text-white/50 hover:text-gold">← Back</Link>
        <h1 className="font-display text-4xl font-bold uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
        <div className="mt-8 space-y-4 text-sm leading-relaxed text-white/60">{children}</div>
      </div>
      <div className="mt-20"><Footer /></div>
    </div>
  );
}

export function Privacy() {
  return (
    <StaticPage title="Privacy">
      <p>DJ Código respects your privacy. We use privacy-conscious, first-party analytics to understand how visitors discover and listen to music. We do not fingerprint users or sell personal data.</p>
      <p>We record anonymous playback and engagement events (page views, play starts, playback milestones, DSP clicks) tied to a random session identifier and, where present, campaign (UTM) parameters. This helps us understand which songs and promotions resonate.</p>
      <p>If you join the Código List, we store your email address and consent timestamp solely to send you news about new music. You can unsubscribe at any time.</p>
      <p>Music playback is provided by Spotify's official embedded player. Spotify may set its own cookies subject to Spotify's privacy policy.</p>
    </StaticPage>
  );
}

export function Terms() {
  return (
    <StaticPage title="Terms">
      <p>This website is the official home of DJ Código. All artwork, music and brand assets are the property of their respective owners.</p>
      <p>Playback is provided through Spotify's official embed. Availability may vary by region, device and account status.</p>
      <p>By using this site you agree to use it for personal, non-commercial music discovery.</p>
    </StaticPage>
  );
}
